import { CommonModule, DecimalPipe, NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { CardModule } from 'primeng/card';
import { forkJoin, map, Subscription } from 'rxjs';
import { TableModule } from 'primeng/table';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { ConfirmationService } from 'primeng/api';
import { GridService } from 'app/Shared/Services/grid.service';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { HttpErrorResponse } from '@angular/common/http';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-cat-comparison',
  imports: [CommonModule, ScrollPanelModule, CardModule, TableModule, DecimalPipe,MatProgressSpinnerModule],
  templateUrl: './cat-comparison.component.html',
  styleUrl: './cat-comparison.component.scss',
})
export class CATComparisonComponent implements OnInit {
  @Input('defaultFilters') DefaultFilterArray: any = [];
  subscription!: Subscription;
  @Input() displayDivider!: boolean;
  Limit: any;
  isLoadingResults = false;

  constructor(
    private emitterService: EmitterService,
    public constantService: ConstantService,
    public confirmationService: ConfirmationService,
    private gridService: GridService,

  ) { }
  ngOnInit() {
    this.subscription = this.emitterService.reloadMainDashBoard.subscribe(value => {
      if (value) {
        this.getComparisonData();
      }
    });
  }

  orderComparisonData: any[] = [];

  orderEquitiesTotal = 0;
  orderOptionsTotal = 0;

  CATorderEquitiesTotal = 0;
  CATorderOptionsTotal = 0;

  routeComparisonData: any[] = [];

  routeEquitiesTotal = 0;
  routeOptionsTotal = 0;

  CATrouteEquitiesTotal = 0;
  CATrouteOptionsTotal = 0;

 calculateVariance(odr: number, cat: number): number | null {
    odr = Number(odr) || 0;
    cat = Number(cat) || 0;
    if (odr === 0 && cat === 0) {
      return 0;
    }
    if (odr === 0) {
      return null;
    }
    return ((odr - cat) / odr) * 100;
  }

  getPercentage(value: number, total: number): number {
    value = Number(value) || 0;
    total = Number(total) || 0;
    if (total === 0) {
      return 0;
    }
    return Number(((value / total) * 100).toFixed(2));
  }

  getTotal(data: any[]): number {
    return data?.reduce(
      (total, item) => total + (item.odr || 0),
      0
    ) || 0;
  }

  getCatTotal(data: any[]): number {
    console.log(data);
    return data?.reduce(
      (total, item) => total + (item.cat || 0),
      0
    ) || 0;
  }
 

  getVarianceClass(value: number | null): string {
    if(value === null){
      return 'variance-red';
    }
    if (value >= 0) {
      return 'variance-green';
    }
    if (Math.abs(value) < 1.5) {
      return 'variance-green';
    }
    return 'variance-red';
  }

  getAbsoluteValue(value:number | null):number{
    return value === null ? 0 : Math.abs(value);
  }

  getComparisonData(filterArr?: any) {
    const FilterArray =
      filterArr ? filterArr : this.DefaultFilterArray;

    this.Limit = {
      Start: '0',
      End: 0
    };
    this.isLoadingResults = true;
    forkJoin({

      odr: this.gridService.prepareData(
        APIURL.ODR_Order_comparison,
        FilterArray,
        this.Limit,
        'ODR_CAT_Comparison'
      ),

      catOrder: this.gridService.prepareData(
        APIURL.CAT_Order_comparison,
        FilterArray,
        this.Limit,
        'ODR_CAT_Comparison'
      ),

      catRoute: this.gridService.prepareData(
        APIURL.CAT_Route_comparison,
        FilterArray,
        this.Limit,
        'ODR_CAT_Comparison'
      )

    }).subscribe({
      next: (response: any) => {
        this.isLoadingResults = false;
        const odrOrder =
          response?.odr?.Data?.OrderODRComparison ?? {};
        const odrRoute =
          response?.odr?.Data?.RouteODRComparison ?? {};
        const catOrder =
          response?.catOrder ?? {};
        const catRoute =
          response?.catRoute ?? {};
        const odrOrderEquities =
          odrOrder?.OrderEquities ?? [];
        const odrOrderOptions =
          odrOrder?.OrderOptions ?? [];
        const odrRouteEquities =
          odrRoute?.routeEquities ?? [];
        const odrRouteOptions =
          odrRoute?.routeOptions ?? [];
        const CATOrderEquities =
          catOrder?.OrderEquities ?? [];
        const CATOrderOptions =
          catOrder?.OrderOptions ?? [];
        const CATRouteEquities =
          catRoute?.routeEquities ?? [];
        const CATRouteOptions =
          catRoute?.routeOptions ?? [];

        const orderCategories = [
          'Held orders',
          'Held non-directed orders',
          'Market orders (held non-directed orders)',
          'Limit orders (held non-directed orders)'
        ];

        this.orderComparisonData = this.mergeComparisonData(
          catOrder.OrderEquities,
          odrOrder.OrderEquities,
          catOrder.OrderOptions,
          odrOrder.OrderOptions,
          orderCategories
        );


        const routeCategories = [
          'Held routes',
          'Held non-directed routes',
          'Market routes (held non-directed routes)',
          'Limit routes (held non-directed routes)'
        ];

        this.routeComparisonData = this.mergeComparisonData(
          catRoute.routeEquities,
          odrRoute.routeEquities,
          catRoute.routeOptions,
          odrRoute.routeOptions,
          routeCategories
        );

        this.orderEquitiesTotal =
          this.getTotal(odrOrderEquities);

        this.orderOptionsTotal =
          this.getTotal(odrOrderOptions);

        this.routeEquitiesTotal =
          this.getTotal(odrRouteEquities);

        this.routeOptionsTotal =
          this.getTotal(odrRouteOptions);

        this.CATorderEquitiesTotal =
         this.getCatTotal(CATOrderEquities);

        this.CATorderOptionsTotal =
          this.getCatTotal(CATOrderOptions);

        this.CATrouteEquitiesTotal =
         this.getCatTotal(CATRouteEquities);

        this.CATrouteOptionsTotal =
          this.getCatTotal(CATRouteOptions);


      },

      error: (err: HttpErrorResponse) => {
        this.isLoadingResults = false;
        this.orderEquitiesTotal = 0;
        this.orderOptionsTotal = 0;
        this.routeEquitiesTotal = 0;
        this.routeOptionsTotal = 0;
        this.CATorderEquitiesTotal = 0;
        this.CATorderOptionsTotal = 0;
        this.CATrouteEquitiesTotal = 0;
        this.CATrouteOptionsTotal = 0;

      }
    });
  }



  mergeComparisonData(catEquities: any[] = [], odrEquities: any[] = [], catOptions: any[] = [], odrOptions: any[] = [], categories: string[]) {
    return categories.map(category => {

      const catEquity = Number(
        catEquities?.find(x => x?.category === category)?.cat
      ) || 0;

      const odrEquity = Number(
        odrEquities?.find(x => x?.category === category)?.odr
      ) || 0;

      const catOption = Number(
        catOptions?.find(x => x?.category === category)?.cat
      ) || 0;

      const odrOption = Number(
        odrOptions?.find(x => x?.category === category)?.odr
      ) || 0;

      return {
        category,

        equities: {
          cat: catEquity,
          odr: odrEquity,
          variance: this.calculateVariance(catEquity, odrEquity)
        },

        options: {
          cat: catOption,
          odr: odrOption,
          variance: this.calculateVariance(catOption, odrOption)
        }
      };
    });
  }

  mergeRows(catData: any[], odrData: any[]){
    return catData.map((catRow: any) => {
      const odrRow = odrData.find(
        (row: any) =>
          row.category?.toLowerCase() === catRow.category?.toLowerCase()
      );
      return {
        category: catRow.category,
        cat: catRow.cat ?? 0,
        odr: odrRow?.odr ?? 0
      };
    });
  }

}